import React from 'react';
import { Button, Col, ButtonToolbar, Dropdown, MenuItem } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ModuleHeader = (props) => {

    const renderFilter = (
        <Col className="module-filters">

            <div className="filter-container">

                {props.withAction && props.withAction}

                <span className="pull-right">
                    <span className="page-label">表示行数</span>
                    <ButtonToolbar className="filter-buttons pull-right">
                        <Dropdown id="num-dropdown">
                            <Button className="fix-right button-num">{props.size} 行</Button>
                            <Dropdown.Toggle className="button-toggle" />
                            <Dropdown.Menu className="num-dropdown">
                                <MenuItem onClick={() => props.setRowLines(20)}>20 行</MenuItem>
                                <MenuItem onClick={() => props.setRowLines(50)}>50 行</MenuItem>
                                <MenuItem onClick={() => props.setRowLines(100)}>100 行</MenuItem>
                            </Dropdown.Menu>
                        </Dropdown>

                        <Button className="button-filter pagination" disabled={1 === props.currPage} onClick={props.prevPage}>前へ</Button>
                        <Button className="button-filter pagination" disabled={props.currPage >= props.maxPage} onClick={props.nextPage}>次へ</Button>

                    </ButtonToolbar>
                </span>
            </div>
        </Col>
    )

    return (
        <Col>
            <Col className={props.mobile ? "module-header-mobile clearfix" : "module-header clearfix"}>
                {props.withReturn ? (
                    <span className="flex-align-center">
                        <Button bsStyle="link" className="mobile-module-return" onClick={props.return}>
                            <FontAwesomeIcon icon="arrow-left" />
                        </Button>
                        {props.title}
                    </span>
                ) : <span className={props.order && "title-module-order"}>{props.title}</span>}
                {props.titleAction && props.titleAction}
            </Col>

            {props.filter && renderFilter}
        </Col>
    );
};

export default ModuleHeader;